module.exports = __webpack_public_path__ + "static/media/building4.1204cbf2.svg";